var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2335 14.2824C12.0999 14.2691 11.9396 14.2691 11.7926 14.2824C8.61321 14.1756 6.08838 11.5706 6.08838 8.36445C6.08838 5.09153 8.73344 2.43311 12.0197 2.43311C15.2927 2.43311 17.9511 5.09153 17.9511 8.36445C17.9377 11.5706 15.4129 14.1756 12.2335 14.2824Z",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9193 5.10474C24.5109 5.10474 26.5949 7.20208 26.5949 9.78035C26.5949 12.3052 24.5911 14.3625 22.0929 14.456C21.9861 14.4426 21.8658 14.4426 21.7456 14.456",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55648 19.2119C2.32362 21.3761 2.32362 24.9028 5.55648 27.0536C9.23017 29.5116 15.255 29.5116 18.9287 27.0536C22.1616 24.8895 22.1616 21.3627 18.9287 19.2119C15.2684 16.7672 9.24353 16.7672 5.55648 19.2119Z",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4995 26.4792C25.4614 26.2788 26.3698 25.8914 27.1179 25.317C29.2018 23.754 29.2018 21.1757 27.1179 19.6127C26.3831 19.0517 25.4881 18.6776 24.5396 18.4639",
    stroke: "#292D32",
    strokeWidth: 2.00383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.e693b268.svg";
export { ForwardRef as ReactComponent };